export const AttendanceType = {
    PRESENT: 'PRESENT',
    TARDY: 'TARDY',
    PERMITTED: 'PERMITTED',
    EXCUSED: 'EXCUSED',
    ABSENT: 'ABSENT',
} as const;
export type AttendanceType = (typeof AttendanceType)[keyof typeof AttendanceType];
